module.exports = "pegasus/assets/blocks/column-lp13-basic.png";